'use strict';

angular.module('gestiondecriseApp').component('crewChecklistComponent', {
  templateUrl: 'views/crew/checklist.html',
  controller: 'CrewChecklistCtrl',
});
